const decodeValue = value => decodeURIComponent(value);
const encodeValue = value => encodeURIComponent(value);
export { decodeValue, encodeValue };
//# sourceMappingURL=decode-encode.js.map